import { defineMessages } from 'react-intl';
// FIXME: traduzir na comunidade

export default defineMessages({
  Accordion: {
    id: 'Accordion',
    defaultMessage: 'Accordion',
  },
  AccordionBlock: {
    id: 'Accordion block',
    defaultMessage: 'Accordion block',
  },
  AccordionTitle: {
    id: 'Accordion title',
    defaultMessage: 'Accordion title',
  },
  accordionTitle: {
    id: 'Accordion',
    defaultMessage: 'Accordion',
  },
  Default: {
    id: 'Default',
    defaultMessage: 'Default',
  },
  headline: {
    id: 'Headline',
    defaultMessage: 'Headline',
  },
  Options: {
    id: 'Options',
    defaultMessage: 'Options',
  },
  Title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  friendly_name: {
    id: 'Friendly name',
    defaultMessage: 'Friendly name',
  },
  title_size: {
    id: 'Title size',
    defaultMessage: 'Title size',
  },
  title_size_description: {
    id: 'Accordion Title size',
    defaultMessage: 'Accordion Title size',
  },
  right_arrows: {
    id: 'Title Icon on the right',
    defaultMessage: 'Title Icon on the right',
  },
  right_arrows_description: {
    id: 'When you have nested accordions, it is recomended to uncheck this option',
    defaultMessage:
      'When you have nested accordions, it is recomended to uncheck this option',
  },
  left_arrows: {
    id: 'Title Icon on the left',
    defaultMessage: 'Title Icon on the left',
  },
  left_arrows_description: {
    id: 'When you have nested accordions, it is recomended to check this option',
    defaultMessage:
      'When you have nested accordions, it is recomended to check this option',
  },
  openOnStart: {
    id: 'First panel open',
    defaultMessage: 'First panel open',
  },
  exclusive: {
    id: 'Keep only one item open',
    defaultMessage: 'Keep only one item open',
  },
  exclusive_description: {
    id: 'When opening a panel, all the others will be closed',
    defaultMessage: 'When opening a panel, all the others will be closed',
  },
  groups: {
    id: 'Change layout to highlight hierarchy',
    defaultMessage: 'Change layout to highlight hierarchy',
  },
  groups_description: {
    id: 'Check this option to highlight titles when you have nested accordions',
    defaultMessage:
      'Check this option to highlight titles when you have nested accordions',
  },
  Theme: {
    id: 'Theme',
    defaultMessage: 'Theme',
  },
  ThemeHelp: {
    id: 'Accordion theme',
    defaultMessage: 'Accordion theme',
  },
  ThemePrimary: {
    id: 'Primary',
    defaultMessage: 'Primary',
  },
  ThemeSecondary: {
    id: 'Secondary',
    defaultMessage: 'Secondary',
  },
  ThemeTertiary: {
    id: 'Tertiary',
    defaultMessage: 'Tertiary',
  },
  EnterTitle: {
    id: 'Enter Title',
    defaultMessage: 'Enter Title',
  },
  AddItem: { id: 'Add item', defaultMessage: 'Add item' },
  SectionHelp: {
    id: 'Section help',
    defaultMessage: 'Section help',
  },
});
